<template>
  <!--弹框7 开始-->
  <el-dialog :visible.sync="frameRemindDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center style="text-align: center;">
    <div style="width:100%;text-align: center;">
      <div><img src="https://res.roompai.com/static/img/frame/clock.png" class="frame-small-img"></div>
      <div class="frame-text-rise">
        <div class="wordBreak">{{$t('stillInterested')}}</div>
        <div class="wordBreak">{{$t('choiceTopSelling')}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-gohome" @click="continueBooking()">{{$t('continueBooking')}}</el-button>
      </span>
    </div>
  </el-dialog>
  <!--弹框7 结束-->
  <!--引入方式-->
  <!-- <frameRemind :frameRemindDialog="frameRemindDialog"></frameRemind> -->
</template>

<script>
export default {
  name: 'frameQuotation',
  props: ['frameRemindDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    continueBooking: function () {
      var submitInfo = {'click': 1}
      this.$emit('continueBookingFun', submitInfo)
    }
  }
}
</script>

<style scoped>
.frame-small-img{width:80px; height:80px;cursor: pointer;}
.frame-text-rise{height:50px; line-height: 22px;font-size: 16px;color: #4F4C4C;text-align: center; margin-top: 10px;}
.dialog-gohome{width: auto;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.dialog-gohome:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
@media screen and (max-width: 1000px) {
.dialog-gohome{width:100%; margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/frameRemind.vue